var exports = {
  "s": "narrow-MEU1b",
};

module.exports = exports;
